import { Link } from "react-router-dom";
import type { Movie } from "@/types/entertainment";

export default function MovieCard({ movie }: { movie: Movie }) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-200 hover:-translate-y-1 hover:border-primary-300"
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden bg-background-200">
        <img
          src={movie.cover}
          alt={`${movie.title} 海报`}
          title={`${movie.title} - 国产影视作品`}
          className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-md bg-foreground-950/70 px-2 py-0.5 text-xs font-medium text-background-50">
          {movie.category === "movie" ? "电影" : "电视剧"}
        </span>
        <span className="absolute right-2 top-2 flex items-center gap-1 rounded-md bg-accent-500 px-2 py-0.5 text-xs font-semibold text-background-50">
          <i className="ri-star-fill text-[10px]" />
          {movie.rating.toFixed(1)}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-3">
        <h3 className="truncate text-sm font-semibold text-foreground-950 group-hover:text-primary-600 md:text-base">
          {movie.title}
        </h3>
        <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-foreground-600">
          {movie.summary}
        </p>
        <div className="mt-2.5 flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-foreground-500">
          <span className="truncate">{movie.actors.slice(0, 2).join(" / ")}</span>
          <span className="text-background-400">·</span>
          <span>{movie.year}</span>
          <span className="rounded bg-background-200 px-1.5 py-0.5 text-foreground-600">
            {movie.type}
          </span>
        </div>
      </div>
    </Link>
  );
}